export const translations = {
  es: {
    nav: {
      home: "Inicio",
      origin: "Origen",
      products: "Productos",
      ritual: "Ritual",
      contact: "Contacto",
      faq: "Preguntas",
      cart: "Carrito",
    },
    hero: {
      eyebrow: "Superalimento Ancestral · Cacao Puro · Origen Único",
      title_1: "Cacao puro de",
      title_2: "El Salvador",
      title_3: "para tu ritual diario.",
      subtitle:
        "Pasta de cacao grado ceremonial, 100% salvadoreña, sin azúcar ni ingredientes agregados. Un superalimento ancestral de Mesoamérica para volver al corazón.",
      cta_shop: "Empezá tu ritual",
      cta_story: "Conocé cómo prepararlo",
    },
    origin: {
      eyebrow: "Origen",
      title: "El cacao nació aquí.",
      body_1:
        "El cacao nació en Mesoamérica como parte de la vida cotidiana de nuestros ancestros: alimento, bebida, encuentro y símbolo de conexión. YULU proviene del náhuatl y significa corazón, el centro de la vida.",
      body_2:
        "Honramos ese origen con cacao salvadoreño puro, sin azúcar ni agregados, trabajado con respeto por su tierra, su historia y su proceso. Un superalimento ancestral que acompaña tu ritual diario con antioxidantes naturales y energía suave.",
      stat_1_label: "Origen único",
      stat_1_value: "Usulután, El Salvador",
      stat_2_label: "Cosecha",
      stat_2_value: "Manual",
      stat_3_label: "Comercio",
      stat_3_value: "Directo y justo",
    },
    products: {
      eyebrow: "La colección",
      title: "Tres formas de habitar el ritual.",
      subtitle:
        "Una colección curada con propósito. Cada presentación responde a un momento distinto del camino.",
      add: "Añadir",
      added: "Añadido",
      view: "Detalles",
    },
    ritual: {
      eyebrow: "El Ritual",
      title: "Cómo preparar tu taza sagrada.",
      step_1_title: "Pesa con intención",
      step_1_body:
        "Entre 25 y 40 gramos por persona. Permite que la cantidad sea un acto consciente, no automático.",
      step_2_title: "Calienta con respeto",
      step_2_body:
        "Agua o leche vegetal a fuego suave. Nunca hervir: el cacao pierde su espíritu en el calor agresivo.",
      step_3_title: "Bate con presencia",
      step_3_body:
        "Disuelve lentamente. Añade especias —canela, cardamomo, chile— según lo que tu cuerpo pida hoy.",
      step_4_title: "Bebe en silencio",
      step_4_body:
        "Antes del primer sorbo, agradece. Deja que el cacao haga su trabajo en tu pecho.",
    },
    testimonials: {
      eyebrow: "Comunidad YULU",
      title: "Quienes ya viven su ritual.",
      cta: "Dejá tu testimonio →",
    },
    testimonialForm: {
      title: "Contanos tu experiencia",
      subtitle:
        "Tu testimonio ayuda a otras personas a animarse a vivir su ritual de cacao. Gracias por compartir 🤎",
      rating_label: "Tu calificación",
      name_label: "Tu nombre",
      name_placeholder: "Como querés que aparezca",
      location_label: "Ciudad (opcional)",
      location_placeholder: "Ej: San Salvador",
      text_label: "Tu testimonio",
      text_placeholder: "¿Cómo viviste tu cacao YULU? ¿Qué cambió en tu ritual diario?",
      consent_label:
        "Autorizo a YULU a publicar mi nombre, ciudad y testimonio en su sitio web y redes.",
      submit: "Enviar testimonio",
      submit_loading: "Enviando...",
      moderation_note:
        "Tu testimonio será revisado antes de publicarse. No publicamos calificaciones falsas.",
      thanks_title: "¡Gracias por tu testimonio!",
      thanks_body:
        "Lo recibimos con cariño. Lo revisaremos y, una vez aprobado, aparecerá en el sitio.",
      back_home: "Volver al inicio",
      error_required: "Por favor ingresá tu nombre.",
      error_text: "Contanos un poco más (mínimo 10 caracteres).",
      error_consent: "Necesitamos tu autorización para publicarlo.",
      error_default: "Hubo un problema al enviar. Intentá de nuevo.",
    },
    faq: {
      eyebrow: "Preguntas frecuentes",
      title: "Todo sobre tu ritual YULU.",
      subtitle:
        "Cacao puro de El Salvador, sin azúcar ni ingredientes agregados. Resolvé tus dudas sobre qué es, cómo prepararlo y de dónde viene.",
      items: [
        {
          q: "¿YULU es chocolate?",
          a: "No. YULU no es chocolate, es cacao puro. A diferencia del chocolate comercial, no contiene azúcar, leche ni ingredientes agregados.",
        },
        {
          q: "¿El cacao YULU tiene azúcar?",
          a: "No. El cacao YULU es cacao sin azúcar, sin leche y sin ingredientes agregados. Podés prepararlo a tu gusto y agregar tu endulzante natural favorito si lo deseás.",
        },
        {
          q: "¿Cómo preparo mi cacao?",
          a: "Cortá y pesá entre 10g y 35g de cacao YULU. Mezclalo con agua caliente, sin hervir, y disfrutalo como una pausa consciente.",
        },
        {
          q: "¿Cuánto cacao debo usar?",
          a: "Si estás empezando, te recomendamos iniciar con 10g. Podés ajustar la cantidad hasta 35g según tu preferencia.",
        },
        {
          q: "¿De dónde viene el cacao YULU?",
          a: "YULU nace en El Salvador y trabaja con cacao salvadoreño de origen único, honrando el cacao como superalimento ancestral de Mesoamérica.",
        },
      ],
    },
    cart: {
      title: "Tu canasta",
      empty: "Aún no hay nada en tu canasta.",
      empty_hint: "Cuando elijas un cacao, aparecerá aquí.",
      subtotal: "Subtotal",
      checkout: "Finalizar pedido",
      checkout_whatsapp: "Pedir por WhatsApp",
      remove: "Quitar",
      shipping_note: "Envío $3 a todo El Salvador.",
      qty: "Cantidad",
    },
    checkout: {
      title: "Finalizar pedido",
      back_to_shop: "Volver a la tienda",
      empty_cart: "Tu carrito está vacío.",
      contact_section: "Contacto",
      shipping_section: "Dirección de envío",
      payment_section: "Método de pago",
      email_label: "Correo electrónico",
      email_placeholder: "tu@correo.com",
      full_name_label: "Nombre completo",
      full_name_placeholder: "Como aparece en tu DUI",
      phone_label: "Teléfono",
      phone_placeholder: "+503 7777-9999",
      departamento_label: "Departamento",
      departamento_placeholder: "Selecciona un departamento",
      municipio_label: "Municipio",
      municipio_placeholder: "Ciudad / Municipio",
      address_label: "Dirección",
      address_placeholder: "Colonia, calle, número de casa",
      address_2_label: "Detalles adicionales (opcional)",
      address_2_placeholder: "Apartamento, referencia, etc.",
      notes_label: "Notas para el repartidor (opcional)",
      notes_placeholder: "Color de la casa, hora preferida, etc.",
      add_optional: "Agregar detalle o nota",
      hide_optional: "Ocultar detalle",
      secure_badge: "Pago seguro · N1CO · 3D Secure",
      pay_amount: "Pagar",
      payment_card: "Tarjeta de crédito o débito",
      payment_card_desc: "Pago en línea seguro con tarjeta vía N1CO.",
      payment_cod: "Contra entrega",
      payment_cod_desc: "Paga en efectivo cuando recibas tu pedido.",
      payment_transfer: "Transferencia bancaria",
      payment_transfer_desc: "Te enviamos los datos por correo después de confirmar.",
      summary_title: "Tu pedido",
      subtotal: "Subtotal",
      shipping: "Envío",
      total: "Total",
      submit: "Realizar pedido",
      submit_card: "Pagar con tarjeta",
      submit_loading: "Procesando...",
      error_default: "Hubo un problema al procesar tu pedido. Intenta de nuevo.",
      error_required: "Este campo es obligatorio",
      error_email: "Correo no válido",
      error_phone: "Teléfono no válido",
    },
    order: {
      title: "Tu pedido",
      number_label: "Número de pedido",
      status_label: "Estado",
      payment_label: "Pago",
      status_pending: "Pendiente",
      status_pending_payment: "Esperando pago",
      status_confirmed: "Confirmado",
      status_shipped: "Enviado",
      status_delivered: "Entregado",
      status_cancelled: "Cancelado",
      pay_pending: "Pendiente",
      pay_paid: "Pagado",
      pay_failed: "Falló",
      pay_refunded: "Reembolsado",
      items_label: "Productos",
      shipping_label: "Enviar a",
      totals_label: "Totales",
      back: "Volver a la tienda",
      retry_payment: "Reintentar pago",
      cod_message: "Te contactaremos por teléfono o WhatsApp para coordinar la entrega.",
      transfer_message: "Te enviaremos los datos bancarios por correo. Cuando hagas el depósito, mándanos el comprobante por WhatsApp.",
      paid_message: "¡Pago recibido! Estamos preparando tu pedido.",
      pending_payment_message: "Estamos esperando la confirmación del pago.",
      failed_payment_message: "El pago no se completó. Puedes reintentar.",
      loading: "Cargando pedido...",
      not_found: "No encontramos este pedido.",
    },
    footer: {
      tagline: "Cacao ceremonial, hecho con manos que recuerdan.",
      contact_label: "Contacto",
      whatsapp_label: "Escríbenos por WhatsApp",
      rights: "Todos los derechos reservados.",
      links_label: "Navegar",
    },
    common: {
      currency: "USD",
    },
  },
  en: {
    nav: {
      home: "Home",
      origin: "Origin",
      products: "Products",
      ritual: "Ritual",
      contact: "Contact",
      faq: "FAQ",
      cart: "Cart",
    },
    hero: {
      eyebrow: "Ancestral Superfood · Pure Cacao · Single Origin",
      title_1: "Pure cacao from",
      title_2: "El Salvador",
      title_3: "for your daily ritual.",
      subtitle:
        "Ceremonial-grade cacao paste, 100% Salvadoran, with no sugar or added ingredients. An ancestral superfood of Mesoamerica to return to the heart.",
      cta_shop: "Start your ritual",
      cta_story: "Learn how to prepare it",
    },
    origin: {
      eyebrow: "Origin",
      title: "Cacao was born here.",
      body_1:
        "Cacao was born in Mesoamerica as part of the daily life of our ancestors: food, drink, gathering, and a symbol of connection. YULU comes from Nahuatl and means heart, the center of life.",
      body_2:
        "We honor that origin with pure Salvadoran cacao, no sugar or additives, crafted with respect for its land, its history, and its process. An ancestral superfood that accompanies your daily ritual with natural antioxidants and gentle energy.",
      stat_1_label: "Single origin",
      stat_1_value: "Usulután, El Salvador",
      stat_2_label: "Harvest",
      stat_2_value: "Hand",
      stat_3_label: "Trade",
      stat_3_value: "Direct & fair",
    },
    products: {
      eyebrow: "The collection",
      title: "Three ways to inhabit the ritual.",
      subtitle:
        "A small collection curated with purpose. Each form responds to a different moment on the path.",
      add: "Add",
      added: "Added",
      view: "Details",
    },
    ritual: {
      eyebrow: "The Ritual",
      title: "How to prepare your sacred cup.",
      step_1_title: "Weigh with intention",
      step_1_body:
        "Between 25 and 40 grams per person. Let the quantity be a conscious act, never automatic.",
      step_2_title: "Heat with respect",
      step_2_body:
        "Water or plant milk over a soft flame. Never boil — cacao loses its spirit in aggressive heat.",
      step_3_title: "Stir with presence",
      step_3_body:
        "Dissolve slowly. Add spices — cinnamon, cardamom, chili — depending on what your body asks today.",
      step_4_title: "Drink in silence",
      step_4_body:
        "Before the first sip, give thanks. Let the cacao do its work in your chest.",
    },
    testimonials: {
      eyebrow: "YULU community",
      title: "Those already living their ritual.",
      cta: "Share your testimonial →",
    },
    testimonialForm: {
      title: "Tell us your experience",
      subtitle:
        "Your testimonial helps others dare to live their own cacao ritual. Thank you for sharing 🤎",
      rating_label: "Your rating",
      name_label: "Your name",
      name_placeholder: "How you'd like it to appear",
      location_label: "City (optional)",
      location_placeholder: "e.g. San Salvador",
      text_label: "Your testimonial",
      text_placeholder: "How did you experience your YULU cacao? What changed in your daily ritual?",
      consent_label:
        "I authorize YULU to publish my name, city, and testimonial on its website and social media.",
      submit: "Send testimonial",
      submit_loading: "Sending...",
      moderation_note:
        "Your testimonial will be reviewed before publishing. We don't publish fake ratings.",
      thanks_title: "Thank you for your testimonial!",
      thanks_body:
        "We received it with love. We'll review it and, once approved, it will appear on the site.",
      back_home: "Back to home",
      error_required: "Please enter your name.",
      error_text: "Tell us a bit more (at least 10 characters).",
      error_consent: "We need your authorization to publish it.",
      error_default: "There was a problem sending it. Please try again.",
    },
    faq: {
      eyebrow: "Frequently asked questions",
      title: "Everything about your YULU ritual.",
      subtitle:
        "Pure cacao from El Salvador, no sugar or added ingredients. Clear your doubts about what it is, how to prepare it, and where it comes from.",
      items: [
        {
          q: "Is YULU chocolate?",
          a: "No. YULU is not chocolate, it is pure cacao. Unlike commercial chocolate, it contains no sugar, milk, or added ingredients.",
        },
        {
          q: "Does YULU cacao have sugar?",
          a: "No. YULU cacao is sugar-free, with no milk or added ingredients. You can prepare it your way and add your favorite natural sweetener if you like.",
        },
        {
          q: "How do I prepare my cacao?",
          a: "Cut and weigh between 10g and 35g of YULU cacao. Mix it with hot water, without boiling, and enjoy it as a mindful pause.",
        },
        {
          q: "How much cacao should I use?",
          a: "If you're just starting, we recommend beginning with 10g. You can adjust up to 35g to your preference.",
        },
        {
          q: "Where does YULU cacao come from?",
          a: "YULU is born in El Salvador and works with single-origin Salvadoran cacao, honoring cacao as an ancestral superfood of Mesoamerica.",
        },
      ],
    },
    cart: {
      title: "Your basket",
      empty: "Your basket is still empty.",
      empty_hint: "When you choose a cacao, it will appear here.",
      subtotal: "Subtotal",
      checkout: "Checkout",
      checkout_whatsapp: "Order via WhatsApp",
      remove: "Remove",
      shipping_note: "$3 shipping anywhere in El Salvador.",
      qty: "Quantity",
    },
    checkout: {
      title: "Checkout",
      back_to_shop: "Back to shop",
      empty_cart: "Your cart is empty.",
      contact_section: "Contact",
      shipping_section: "Shipping address",
      payment_section: "Payment method",
      email_label: "Email",
      email_placeholder: "you@email.com",
      full_name_label: "Full name",
      full_name_placeholder: "As shown on your ID",
      phone_label: "Phone",
      phone_placeholder: "+503 7777-9999",
      departamento_label: "Department",
      departamento_placeholder: "Select a department",
      municipio_label: "City / Municipality",
      municipio_placeholder: "City / Municipality",
      address_label: "Address",
      address_placeholder: "Neighborhood, street, house number",
      address_2_label: "Additional details (optional)",
      address_2_placeholder: "Apartment, reference, etc.",
      notes_label: "Delivery notes (optional)",
      notes_placeholder: "House color, preferred time, etc.",
      add_optional: "Add detail or note",
      hide_optional: "Hide detail",
      secure_badge: "Secure payment · N1CO · 3D Secure",
      pay_amount: "Pay",
      payment_card: "Credit or debit card",
      payment_card_desc: "Secure online card payment via N1CO.",
      payment_cod: "Cash on delivery",
      payment_cod_desc: "Pay in cash when you receive your order.",
      payment_transfer: "Bank transfer",
      payment_transfer_desc: "We'll send you the bank details by email after confirmation.",
      summary_title: "Your order",
      subtotal: "Subtotal",
      shipping: "Shipping",
      total: "Total",
      submit: "Place order",
      submit_card: "Pay with card",
      submit_loading: "Processing...",
      error_default: "There was a problem processing your order. Please try again.",
      error_required: "This field is required",
      error_email: "Invalid email",
      error_phone: "Invalid phone",
    },
    order: {
      title: "Your order",
      number_label: "Order number",
      status_label: "Status",
      payment_label: "Payment",
      status_pending: "Pending",
      status_pending_payment: "Awaiting payment",
      status_confirmed: "Confirmed",
      status_shipped: "Shipped",
      status_delivered: "Delivered",
      status_cancelled: "Cancelled",
      pay_pending: "Pending",
      pay_paid: "Paid",
      pay_failed: "Failed",
      pay_refunded: "Refunded",
      items_label: "Items",
      shipping_label: "Ship to",
      totals_label: "Totals",
      back: "Back to shop",
      retry_payment: "Retry payment",
      cod_message: "We'll contact you by phone or WhatsApp to coordinate delivery.",
      transfer_message: "We'll send the bank details by email. After your deposit, send us the receipt via WhatsApp.",
      paid_message: "Payment received! We're preparing your order.",
      pending_payment_message: "Waiting for payment confirmation.",
      failed_payment_message: "The payment didn't go through. You can retry.",
      loading: "Loading order...",
      not_found: "We couldn't find this order.",
    },
    footer: {
      tagline: "Ceremonial cacao, made by hands that remember.",
      contact_label: "Contact",
      whatsapp_label: "Message us on WhatsApp",
      rights: "All rights reserved.",
      links_label: "Navigate",
    },
    common: {
      currency: "USD",
    },
  },
};
